import React from 'react';

import CoursesView from '../components/organisms/CoursesView';
import PageTemplate from '../components/templates/PageTemplate';

const CoursesContainer = () => (
  <PageTemplate>
    <CoursesView />
  </PageTemplate>
);

export default CoursesContainer;
